import { createSlice } from "@reduxjs/toolkit";

import { EMPTY_ARRAY } from "@/react/empty";

export const name = "user";

const initialState = {
  user: {},
};

const userSlice = createSlice({
  name,
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const userSelector = (state) => state[name].user;

export const userGroupsSelector = (state) =>
  userSelector(state)?.groups ?? EMPTY_ARRAY;

export const { setUser } = userSlice.actions;
export default userSlice.reducer;
